const resource = {
  resources: "Ressources",
  resource: "Resource",
  type: "Type",
  name: "Resource name",
  description: "Description",
  linkToDocument: "Link to the document",
  missingLink: "Link missing",
};

export default resource;
